import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler,
  Legend
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Card, Form } from "react-bootstrap";
import { monthOptions } from "../../constants/Constants";
import React from "react";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler,
  Legend
);


function BillingOverviewChart({ billingMonth, setBillingMonth, billingOverview }) {

  const chartValues =
    billingOverview?.chartData?.map((m) => m.total) || [];

  const allZero = chartValues.every((v) => v === 0);

  const data = {
    labels: billingOverview?.chartData?.map((m) => m.label) || [],
    datasets: allZero
      ? []
      : [
        {
          label: "",
          data: chartValues,
          borderColor: "#2563eb",
          backgroundColor: "rgba(37, 99, 235, 0.08)",
          fill: true,
          tension: 0.4,
          pointRadius: 0,
          borderWidth: 2,
        },
      ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: { display: false },
      },
      y: {
        min: 0,
        max: allZero ? 10 : undefined,
        ticks: {
          callback: (value) => {
            if (value >= 1000000) {
              return `$${(value / 1000000).toFixed(1)}M`;
            }

            if (value >= 1000) {
              return `$${(value / 1000).toFixed(1)}K`;
            }

            return `$${value}`;
          },
        },
        grid: {
          color: "#e5e7eb",
        },
      },
    },
  };

  return (
    <Card className="bo-card">

      {/* HEADER */}
      <div className="bo-header">
        <div className="title">
          Billing Overview
          <span className="info">ⓘ</span>
        </div>
        <div>
        <Form.Select size="sm" className="range-select " value={billingMonth?.month} onChange={(e) => setBillingMonth({ ...billingMonth, month: e.target.value })}>
          {monthOptions.map((opt, id) => {
            return <option key={id} value={opt.value}>
              {opt.label}
            </option>
          })}
          </Form.Select>
          </div>
      </div>

      {/* BODY */}
      <div className="bo-body">

        {/* LEFT SIDE */}
        <div className="bo-left">
          <p className="label">Total Charges</p>
          <h3>${billingOverview?.totalMonthAmount?.toFixed(2) || "0"}</h3>
          {/* <span className="growth">↑ 12% vs Mar 2026</span> */}
        </div>

        {/* RIGHT CHART */}
        <div className="bo-chart">
          {allZero ? (
            <Line
              data={{
                labels: billingOverview?.chartData?.map((m) => m.label) || [],
                datasets: [],
              }}
              options={options}
            />
          ) : (
            <Line data={data} options={options} />
          )}
        </div>

      </div>

    </Card>
  );
}

export default React.memo(BillingOverviewChart);